import { Component, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Button } from '../../common/components/form-components/button/button';
import { Password } from '../../common/components/form-components/password/password';
import { LoginService } from '../services/login-service';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ApiResponse } from '../../common/models/api-response';

@Component({
  selector: 'app-reset-verify',
  imports: [CommonModule, RouterLink, ReactiveFormsModule, Password, Button],
  templateUrl: './reset-verify.html',
  styleUrl: './reset-verify.scss'
})
export class ResetVerify {
  resetForm!: FormGroup;
  loading: boolean = false;
  isPasswordReset: boolean = false;
  isTokenVerfied: any = null;
  submitted: boolean = false;
  userId: string = '';
  private destroy$ = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private loginService: LoginService,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef
  ) {
    const token = this.route.snapshot.queryParamMap.get('token');
    if (token) {
      this.verifyResetToken(token);
    }
  }

  ngOnInit() {
    this.resetForm = this.fb.group({
      password: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]],
    }, { validators: this.passwordMatchValidator });
  }

  verifyResetToken(token: any) {
    this.loginService.verifyResetToken(token).pipe(
      takeUntil(this.destroy$)).subscribe({
        next: (response: ApiResponse<any>) => {
          if (response.responseCode == 200 && response.message == 'Token is valid') {
            this.loading = false;
            this.isTokenVerfied = true;
            this.userId = response.data.userId;
          } else if (response.responseCode == 400 && response.message == 'Token is not valid') {
            this.loading = false;
            this.isTokenVerfied = false;
          }
          this.cd.detectChanges();
        },
        error: (error: any) => {
          this.loading = false;
          this.isTokenVerfied = false;
          this.cd.detectChanges();
        }
      })
  }

  passwordMatchValidator(form: FormGroup) {
    const password = form.get('password')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;

    if (password && confirmPassword && password !== confirmPassword) {
      form.get('confirmPassword')?.setErrors({ passwordMismatch: true });
      return { passwordMismatch: true };
    } else {
      if (form.get('confirmPassword')?.hasError('passwordMismatch')) {
        form.get('confirmPassword')?.setErrors(null);
      }
      return null;
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.resetForm.valid) {
      if (this.resetForm.get('password')?.value !== this.resetForm.get('confirmPassword')?.value) {
        return;
      }
      const payload = {
        userId: this.userId,
        newPassword: this.resetForm.get('password')?.value,
        confirmPassword: this.resetForm.get('confirmPassword')?.value
      }
      this.loading = true;
      this.loginService.resetpassword(payload).pipe(
        takeUntil(this.destroy$)).subscribe({
          next: (response: ApiResponse<any>) => {
            if (response.responseCode == 200 && response.message == 'Success') {
              this.loading = false;
              this.isPasswordReset = true;
            } else if (response.responseCode == 400) {
              this.loading = false;
              this.isPasswordReset = false;
            }
            this.cd.detectChanges();
          },
          error: (error: any) => {
            this.loading = false;
            this.isPasswordReset = false;
            this.cd.detectChanges();
          }
        })
      console.log('Reset password request for:', this.resetForm.value);
    } else {
      this.resetForm.markAllAsTouched();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
